import { matchPath } from 'react-router-dom';
import { ROUTES, ROUTE_PARAMS, PREDICT_PRODUCT_SLUG } from '../../app-core';
import { getProductRoute } from '../../organisations';
import { interpolatePathParams, joinRouteMatchUrl } from '../../path';

// ***************
// * Route paths *
// ***************

export const getOnboardingEditReportRoutePath = () => {
  return joinRouteMatchUrl(
    '',
    getProductRoute(),
    ROUTES.REPORTING_EDIT,
    ROUTES.ONBOARDING_ROUTE,
    `:${ROUTE_PARAMS.STEP_ID}`
  );
};

export const getOnboardingReportingRoutePath = () => {
  return joinRouteMatchUrl('', getProductRoute(), ROUTES.REPORTING, ROUTES.ONBOARDING_ROUTE);
};

// *************
// * Page URLs *
// *************

export const getOnboardingEditReportUrl = (
  workspaceId: string,
  organisationId: string,
  reportId: string,
  step: string | number
): string =>
  interpolatePathParams(getOnboardingEditReportRoutePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
    [ROUTE_PARAMS.REPORT_ID]: reportId,
    [ROUTE_PARAMS.STEP_ID]: step.toString()
  });

export const getOnboardingReportingUrl = (workspaceId: string, organisationId: string): string =>
  interpolatePathParams(getOnboardingReportingRoutePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });

// ******************
// * Route matchers *
// ******************

export const matchOnboardingEditReportUrl = (url: string) => {
  return matchPath(getOnboardingEditReportRoutePath(), url);
};

export const matchOnboardingReportingUrl = (url: string) => {
  return matchPath(getOnboardingReportingRoutePath(), url);
};
